import { createFileRoute } from '@tanstack/react-router'
import { ListPetPage } from '_/features/pets/ui/pages/list-pet-page'

export const Route = createFileRoute('/_authenticated/pets/')({
	staticData: { title: 'pets_title' },
	component: ListPetPage,
})
